import { Repository, EntityRepository, getManager } from 'typeorm';
import { GrnQtyRequest } from '../dto/grn-qty-request';
import { Grn } from '../grn.entity';
import { GrnIdRequest } from '../dto/grn-request';
import appSettings from 'apps/services/config';


@EntityRepository(Grn)
export class GrnRepository extends Repository<Grn>{

    /**
     *
     * @param PurchaseOrderId the po id
     */
    async getGrnQty(poReq: GrnQtyRequest): Promise<any> {
        try {

            const prevAcceptedQyy = this.createQueryBuilder('Grn')
                .select(' sum(grnItemsInfo.acceptedQuantity) as quantity')
                .leftJoin('Grn.grnItemsInfo', 'grnItemsInfo')
                .where(` Grn.poId= '${poReq.purchaseOrderId}' and grnItemsInfo.saleOrderId='${poReq.saleOrderId}' and grnItemsInfo.itemCategoryId = '${poReq.itemCategoryId}' and grnItemsInfo.itemId = '${poReq.itemId}'`)
                .getRawOne();
            return prevAcceptedQyy;
        } catch (err) {
            throw err;
        }
    }

    async getGrnDataByPoId(poReq: GrnQtyRequest): Promise<any> {
        try {

            const grnData = this.createQueryBuilder('Grn')
                .select(' count(*) as count,max(grn_date) as grnDate')
                .where(` Grn.poId= '${poReq.purchaseOrderId}'`)
                .getRawOne();
            return grnData;
        } catch (err) {
            throw err;
        }
    }

    /**
     * 
     * @param grnId 
     * @returns 
     */
    async getGrnData(grnId: number): Promise<any> {
        const grnEntity = await this.createQueryBuilder("Grn")
            .leftJoinAndSelect('Grn.grnItemsInfo', 'grnItemsInfo')
            .where(` Grn.grnId= '${grnId}' `)
            .getOne();
        return grnEntity;
    }

    async getInspectedGrnInfo(req:GrnIdRequest):Promise<any>{
        const manager = getManager()
        let infoQuery =  `SELECT g.grn_id,g.grn_no,g.inv_no,g.vendor_id,gi.po_quantity,gi.accepted_quantity,gi.rejected_quantity,gi.received_quantity,gi.unit_price,gi.discount_per,gi.discount_amount,t.tax_percentage AS tax_per,gi.tax_amount,gi.tot_amount,gi.item_category_id,gi.item_id,i.item_name,ic.item_category,v.vendor_name,g.po_id,gi.grn_item_id,so.po_number AS saleOrderNumber,po.po_number,v.vendor_code
        FROM ${appSettings.procure_db} .grn g
        LEFT JOIN ${appSettings.procure_db} .grn_items gi ON gi.grn_id = g.grn_id
        LEFT JOIN ${appSettings.masters_db} .vendors v ON v.vendor_id = g.vendor_id
        LEFT JOIN ${appSettings.masters_db} .item_categories ic ON ic.item_category_id = gi.item_category_id
        LEFT JOIN ${appSettings.masters_db} .items i ON i.item_id = gi.item_id
        LEFT JOIN ${appSettings.sales_db} .so_invoice_details so ON so.sale_order_id = gi.sale_order_id
        LEFT JOIN ${appSettings.procure_db} . purchase_order po ON po.purchase_order_id = gi.po_id
        LEFT JOIN ${appSettings.masters_db} .taxes t ON t.tax_id = gi.tax_per
        WHERE g.grn_id = ${req.grnId}`
        return await manager.query(infoQuery)
    }

}
